<template>
  <v-container fluid grid-list-sm>
    <template v-if="isExistingDocument">
      <v-flex d-flex xs12 pa-2>
        <AuditDataHeader />
      </v-flex>

      <v-flex xs12 pa-2>
        <v-card>
          <v-tabs v-model="tabs" centered slider-color="primary" show-arrows>
            <v-tab
              v-for="(tab,tab_id) in currentTabs"
              :key="tab_id"
              :id="tab.id"
              :to="tab.route"
              :class="{ active: tab.active }"
            >{{ tab.description }}</v-tab>
          </v-tabs>
        </v-card>
      </v-flex>

      <v-flex xs12 pa-2>
        <v-card>
          <div>
            <v-fade-transition>
              <keep-alive>
                <router-view></router-view>
              </keep-alive>
            </v-fade-transition>
          </div>
        </v-card>
      </v-flex>
    </template>
    <template v-else>
      <v-flex xs12 pa-2>
        <!-- TODO: Stylischer machen -->
        <h1>404 Document not found</h1>
      </v-flex>
    </template>
  </v-container>
</template>

<i18n>
  {
    "de": {
      "audit_preparation" : "Audit Vorbereiten",
      "audit_execution" : "Audit Durchführen",
      "audit_wrapup" : "Audit Nachbereiten",
      "audit_reporting" : "Audit Reporting",
      "audit_actionlist" : "Maßnahmen umsetzen"
    },
    "en": {
      "audit_preparation" : "Prepare",
      "audit_execution" : "Execute",
      "audit_wrapup" : "Wrapping Up",
      "audit_reporting" : "Report",
      "audit_actionlist" : "Execution"
    }
  }
</i18n>

<script>
import AuditDataHeader from "@/components/widgets/AuditDataHeader";

import { mapGetters, mapActions } from "vuex";
import { api } from "@/store/modules/audit";

export default {
  name: "Audit",
  components: {
    AuditDataHeader
  },
  props: {
    auditId: {
      type: String,
      required: true
    }
  },
  watch: {
    auditId: {
      immediate: true,
      handler(NewAuditId) {
        console.log("AUDIT.VUE, CHANGE auditId", NewAuditId);
        this.setAudit(NewAuditId);
      }
    }
  },
  beforeDestroy() {
    console.log("AUDIT.VUE, DESTROY auditId", this);
    this.clearAudit();
  },
  data: () => ({
    tabs: null
  }),
  computed: {
    ...mapGetters(api.namespace, [
      api.getters.getAuditStatus,
      api.getters.isExistingDocument,
      api.getters.getDocumentOnlineState
    ]),
    currentTabs() {
      let status = this.getAuditStatus;

      return {
        "1": {
          id: "tab1",
          active: status == 1,
          description: this.$i18n.t("audit_preparation"),
          route: `/audit/${this.auditId}/auditpreparation`
        },
        "2": {
          id: "tab1",
          active: status == 2,
          description: this.$i18n.t("audit_execution"),
          route: `/audit/${this.auditId}/auditexecution`
        },
        "3": {
          id: "tab1",
          active: status == 3,
          description: this.$i18n.t("audit_wrapup"),
          route: `/audit/${this.auditId}/auditwrapup`
        },
        "4": {
          id: "tab1",
          active: status == 4,
          description: this.$i18n.t("audit_reporting"),
          route: `/audit/${this.auditId}/auditreporting`
        },
        "5": {
          id: "tab1",
          active: status == 5,
          description: this.$i18n.t("audit_actionlist"),
          route: `/audit/${this.auditId}/auditactionlist`
        }
      };
    }
  },
  methods: {
    ...mapActions(api.namespace, [api.actions.setAudit, api.actions.clearAudit])
  }
};
</script>

<style scoped>
.active {
  background-color: lightgray;
}
</style>
